// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__OCA8K","invert":"styles_invert__tBjoF"};